import { SchemaAdapter } from "../base/SchemaAdapter";

import clientSpecialCases from "./clientSpecialCases.config.json";
import serverSpecialCases from "./serverSpecialCases.config.json";

import Logger from "@/helper/logger";
import { type APIKey } from "@/types/apiKey/client";
import { type APIKeyServer } from "@/types/apiKey/server";

// Add these constants after the imports
const DEFAULT_VALUES: APIKeyServer = {
  id: "1",
  display_name: "API Key",
  api_key: "1234567890",
  created_at: "2021-01-01",
  updated_at: "2021-01-01",
  created_by: { id: Math.floor(Math.random() * 1000000), display_name: "Unknown User", email: "Unknown Email User" },
  updated_by: { id: Math.floor(Math.random() * 1000000), display_name: "Unknown User", email: "Unknown Email User" },
} as const;

export class APIKeyAdapter extends SchemaAdapter<APIKey, APIKeyServer> {
  public constructor() {
    super("APIKeyAdapter", {
      enableLogging: Logger.shouldLog(),
    });

    this.camelCaseSpecialConversion = this.flattenJsonConfig(clientSpecialCases);
    this.snakeCaseSpecialConversion = this.flattenJsonConfig(serverSpecialCases);
  }

  /**
   * Get default frontend API key
   * @returns The default API key object
   */
  public getDefaultClient(): APIKey {
    return this.fromBackend(DEFAULT_VALUES).data;
  }

  public getDefaultServer(): APIKeyServer {
    const now = new Date().toISOString();

    const defaultValue = {
      ...DEFAULT_VALUES,
      created_at: now,
      updated_at: now,
    };
    return defaultValue;
  }
}

// Export singleton instance
export const apiKeyAdapter = new APIKeyAdapter();
